import {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router';
import AppContext from './App.context';
import {
  isV3Layout, isV2TwoColumnsLayout, isV2OneColumnLayout,
} from '../pages/registration/RegistrationNavBar/editLayoutStyle/editLayoutStyle.services';

export const GlobalEventSettingsContext = createContext();

const defaultEventData = {
  regLayout: null,
  recurringSimulive: false,
  eventTitle: '',
  eventType: '',
  format: '',
  rolloverToLive: false,
  testWebcast: false,
  consoleBuilderUrl: '',
  adminAccessManageReg: false,
  realStartTime: '',
  hybridMode: false,
  liveEndPast: true,
  eventDisabled: true,
};

export const GlobalEventSettingsProvider = ({ children }) => {
  const { defaultFetchOptions } = useContext(AppContext);
  const { eventId } = useParams();

  const [eventData, setEventData] = useState(defaultEventData);
  const [isLoading, setIsLoading] = useState(false);

  const getEventSettings = async () => {
    setIsLoading(true);
    const resp = await fetch(`/webcast/webapi/eventData/overallData/${eventId}`, {
      method: 'GET',
      headers: {
        ...defaultFetchOptions.headers,
      },
    });
    const data = await resp.json();
    if (data) {
      setEventData(data?.eventData);
    }
  };

  useEffect(() => {
    if (eventId && defaultFetchOptions && !isLoading) {
      getEventSettings();
    }
    return () => {};
  }, [eventId, defaultFetchOptions]);

  const contextValues = useMemo(() => ({
    isReg30: isV3Layout(eventData.regLayout),
    isReg20TwoColumns: isV2TwoColumnsLayout(eventData.regLayout),
    isReg2OneColumn: isV2OneColumnLayout(eventData.regLayout),
    isArchiveEnabled: !eventData.recurringSimulive,
    eventTitle: eventData.eventTitle,
    eventType: eventData.eventType,
    format: eventData.format,
    rolloverToLive: eventData.rolloverToLive,
    testWebcast: eventData.testWebcast,
    consoleBuilderUrl: eventData.consoleBuilderUrl,
    adminAccessManageReg: eventData.adminAccessManageReg,
    realStartTime: eventData.realStartTime,
    hybridMode: eventData.hybridMode,
    closedCaptionUrl: eventData.closedCaptionUrl,
    liveEndPast: eventData.liveEndPast,
    eventDisabled: eventData.eventDisabled,
  }), [eventData, isV3Layout, isV2OneColumnLayout, isV2TwoColumnsLayout]);

  return (
    <GlobalEventSettingsContext.Provider
      value={contextValues}
    >
      {children}
    </GlobalEventSettingsContext.Provider>
  );
};

GlobalEventSettingsProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
